import styled from 'styled-components';

export const SearchGoogleContainer = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  width: calc(100% - 16px);
  max-width: 340px;
  border-radius: ${({ theme }) => theme.shapes.borderRadius};
  box-shadow: ${({ theme }) => theme.shapes.boxShadow};

  input {
    height: 40px;
    width: 100%;
    padding: 4px 56px 4px 10px;
    border-color: transparent;
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
  }

  .search-in-map-icon {
    font-size: 18px;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.colors.text1};
  }

  .search-in-map-close {
    position: absolute;
    top: 50%;
    right: 36px;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.colors.text2};
    font-size: 14px;
    cursor: pointer;
    transition: 0.5s;
    display: flex;

    :hover {
      color: ${({ theme }) => theme.colors.text};
    }
  }
`;
